import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { env } from '@repo/env';
import { PromotionVariantContext } from './promotion-variant-context';
export function PromotionVariantContextProvider(_a) {
    var children = _a.children;
    var _b = useState(env.VITE_PRAGMA_PROMOTION_VARIANT), pragmaPromotionVariant = _b[0], setPragmaPromotionVariant = _b[1];
    return (_jsx(PromotionVariantContext.Provider, { value: {
            pragmaPromotionVariant: pragmaPromotionVariant,
            setPragmaPromotionVariant: setPragmaPromotionVariant,
        }, children: children }));
}
